export const modules = [
  {
    id: "finanzas",
    name: "Finanzas",
    desc: "Ingresos, egresos, categorías, centros de coste y comprobantes.",
  },
  {
    id: "comunicaciones",
    name: "Comunicaciones",
    desc: "Envíos masivos, grupos de mensajes y notificaciones a miembros.",
  },
  {
    id: "archivos",
    name: "Archivos",
    desc: "1 GB de almacenamiento para documentos, actas y multimedia.",
  },
  {
    id: "reportes",
    name: "Reportes",
    desc: "Informes avanzados descargables y métricas detalladas.",
  },
];

export const storageOptions = ["+3 GB · 1,49 €/mes", "+5 GB · 2,49 €/mes", "+10 GB · 4,49 €/mes"];
